export function attuchHeight(content) {
    let windowInnerHeight = window.innerHeight;
    const offsetHeader = document.getElementById('header').getBoundingClientRect().height;
    let elem = document.getElementById(content);

    if (elem) {
      elem.style.height = Math.round(windowInnerHeight - offsetHeader) + 'px';
    }
  }
